var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanada({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4144 2.75867H3.58691V13.2415H12.4144V2.75867Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19828 2.75854C0.536469 2.75854 0 3.29501 0 3.95683V12.043C0 12.7048 0.536469 13.2413 1.19828 13.2413H3.58622V2.75854H1.19828Z",
    fill: "#FF4B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.802 2.75854H12.4141V13.2413H14.802C15.4638 13.2413 16.0003 12.7048 16.0003 12.043V3.95683C16.0003 3.29501 15.4638 2.75854 14.802 2.75854Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67372 9.21116L11.3107 8.27578L10.9351 8.08797C10.8297 8.03528 10.7694 7.92153 10.785 7.80475L10.9072 6.88844L10.2142 7.09007C10.0611 7.13463 9.90222 7.04044 9.86778 6.88478L9.80141 6.58478L9.15069 7.34635C9.06051 7.45191 8.88863 7.37128 8.91216 7.23444L9.19007 5.61857L8.7646 5.73491C8.64032 5.76891 8.50907 5.71235 8.44848 5.59866L8.00045 4.75894V4.75769L8.00013 4.75832L7.99979 4.75769V4.75894L7.55176 5.59866C7.4911 5.71232 7.35985 5.76888 7.23557 5.73491L6.8101 5.61857L7.08801 7.23444C7.11154 7.37125 6.93967 7.45191 6.84945 7.34638L6.19873 6.58482L6.13236 6.88482C6.09792 7.0405 5.93904 7.13463 5.78595 7.0901L5.09292 6.88847L5.21514 7.80478C5.23073 7.92153 5.17042 8.03532 5.06508 8.088L4.68945 8.27578L6.32642 9.21119C6.49598 9.3081 6.57029 9.5136 6.50189 9.6965L6.36195 10.0708L7.7646 9.95103C7.84223 9.94441 7.90829 10.0069 7.90601 10.0848L7.86182 11.5861H8.13769L8.09345 10.0847C8.09116 10.0068 8.15723 9.94435 8.23485 9.95097L9.63816 10.0708L9.49822 9.6965C9.42988 9.51357 9.50416 9.30803 9.67372 9.21116Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/canada.0b1ba47ee59bc12596758d6fd634f361.svg";
export { ForwardRef as ReactComponent };